<template> </template>
<script>
export default {
  name: "Files",
  mounted() {
    const swalWithBootstrapButtons = this.$swal.mixin({
      customClass: {
        confirmButton: "question-btn-confirm mr-2",
        cancelButton: "question-btn-cancel",
      },
      buttonsStyling: false,
      didClose: () => {
        this.$emit("didClose");
      },
    });
    swalWithBootstrapButtons
      .fire({
        title: "The file is in process.",
        text:
          "It may take up to 10-15 minutes. You cannot download another file during the process. You can wait here or be redirected to the files table.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Files",
        cancelButtonText: "Cancel",
        showClass: {
          popup: "animate__animated animate__fadeIn animate__faster",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOut animate__faster",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: "Files" });
        }
      });
  },
};
</script>
